<template>
  <div class="p-8">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">
        Broadcast Campaigns
      </h1>

      <button
        class="bg-blue-600 text-white px-4 py-2 rounded"
        @click="createCampaign"
      >
        + New Campaign
      </button>
    </div>

    <table class="table-auto border-collapse border border-gray-500">
      <thead>
        <tr>
          <th class="border p-2">Name</th>
          <th class="border p-2">Status</th>
          <th class="border p-2">Channel</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="campaign in campaigns"
          :key="campaign.id"
        >
          <td class="border p-2">{{ campaign.name }}</td>
          <td class="border p-2">{{ campaign.status }}</td>
          <td class="border p-2">{{ campaign.channel }}</td>
        </tr>
      </tbody>
    </table>
  </div>
<CreateCampaignModal
  :show="showModal"
  @close="showModal = false"
  @save="saveCampaign"
/>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import CreateCampaignModal from './components/CreateCampaignModal.vue';

const store = useStore();

const showModal = ref(false);


const campaigns = computed(
  () => store.state.broadcastCampaigns.records
);

onMounted(() => {
  store.dispatch('broadcastCampaigns/get');
});

function createCampaign() {
  showModal.value = true;
}

async function saveCampaign(data) {
  await store.dispatch('broadcastCampaigns/create', {
    broadcast_campaign: {
      name: data.name,
      channel: 'whatsapp',
      template_name: data.template,
    },
  });

  showModal.value = false;

  store.dispatch('broadcastCampaigns/get');
}
</script>
